import CommonToggleContainer from "../../Common/CommonToggleContainer";
import ToggleItem from "../../Common/ToggleItem";
import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import RemoteSprite from "../../Common/RemoteSprite";
import { Global } from "../../Shared/Global";
import Utils from "../../Shared/Utils";
import SDKManager from "../../Shared/SDKManager";
import Player from "../../Models/Player";
const i18n = require('LanguageData');

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChangeLanguageLayer extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Node)
    templateItem: cc.Node = null

    private _isSelectedToggles = false
    private _languageData = []
    private _toggleBefore = null
    
    onLoad () {
        this.templateItem.parent = null
    }

    async start () {
        this._languageData = await this.getLanguageData()
        this.initToggles()
        this._toggleBefore = this.toggleContainer.checkedToggle
        this._isSelectedToggles = true
    }

    onDestroy () {
        this.templateItem.destroy()
    }
    
    onToggleSelected (toggle: ToggleItem) {
        if (!this._isSelectedToggles || this.toggleContainer.checkedToggle === this._toggleBefore) return
        if (toggle["languageCfg"].status !== 1) {
            UIManager.showToastUI("该语言不接受预览，请联系商务", Global.ToastType.Warnning)
            this._toggleBefore && this.toggleContainer.selectToggle(this._toggleBefore)
        }else {
            SDKManager.setTags([toggle["languageCfg"].languageFlag])
            i18n.init(toggle["languageCfg"].languageFlag)
            cc.sys.localStorage.setItem("CurrentLanguage", toggle["languageCfg"].languageFlag);
            if (!Player.isLogedIn()){
                Global.currencySymbol = i18n.t("currency_symbol")
            }
            UIManager.showTipUI(i18n.t("set_text.change_language_tips"), function () {
                Utils.restartGame()
            }.bind(this), i18n.t("set_text.restart"))
            this._toggleBefore = this.toggleContainer.checkedToggle
        }
    }

    private getLanguageData () : Promise<any> {
        return new Promise<any>(resolve => {
            NetworkLogic.getLanguageListAll(function (data) {
                resolve(data)
            }.bind(this), function (response) {
                resolve([])
            }.bind(this))
        })
    }

    private initToggles () {
        let language = cc.sys.localStorage.getItem("CurrentLanguage")
        for (let j = 0; j < this._languageData.length; j++) {
            const item = this._languageData[j];
            if (item.status !== 1) {
                continue
            }
            let toggle = cc.instantiate(this.templateItem).getComponent(ToggleItem)
            this.toggleContainer.addToggle(toggle)
            toggle["languageCfg"] = item
            language === item.languageFlag && this.toggleContainer.selectToggle(toggle)
            toggle.node.getChildByName("flag").getComponent(RemoteSprite).url = item.languageUrl
            toggle.node.getChildByName("name").getComponent(cc.Label).string = item.languageName
        }
        !this.toggleContainer.checkedToggle && this.toggleContainer.selectFirstItem()
    }
}
